import styled from '@emotion/styled';

export const StyledWrapper = styled('div')`
    grid-area: pageTitle;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
`;

export const StyledHeader = styled('div')`
    display: flex;
    flex-direction: column;
`;

export const StyledTitle = styled('div')`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
`;

export const StyledNav = styled('div')`
    display: flex;
    gap: 1.5rem;
`;
